import { useApiToast } from 'components/Toaster';
import { useEffect, useState } from 'react';
import { useGetDashboardMutation } from 'services/dashboard/dashboard.endpoint';
import { Dashboard } from 'services/dashboard/dashboard.types';
import { Appointment } from 'services/appointment/appointment.types';

export default function useDashboardVM() {
    const [dashboardData, setDashboardData] = useState<Dashboard>();
    const { showErrorToast } = useApiToast();

    const [getDashboard, {isLoading, isError, isSuccess, error, data }] = useGetDashboardMutation();

    console.log('dashboardData', dashboardData);

    useEffect(() => {
        getDashboard(undefined);
    }, []);

    useEffect(() => {
        if (isLoading) return;
        if (isError && error) {
            showErrorToast(error, {
                message: 'Erreur de chargement du tableau de bord'
            });
            return;
        }
        if (isSuccess && data) {
            setDashboardData(data.data);
            return;
        }
    }, [isLoading, isError, isSuccess, error, data]);

    return {
        isLoading,
        dashboardData,
    };
}
